export const APP_ID = parseInt(process.env.REACT_APP_ID,10);
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const CLIENT_VERSION = process.env.REACT_APP_CLIENT_VERSION;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const RESUME_LAST_UPDATED = process.env.REACT_APP_RESUME_LAST_UPDATE;